export const PAYMENT_METHODS_ICONS = {
  credit_card: {
    name: 'uil-credit-card',
    transform: 'width-18'
  },
  boleto: {
    name: 'uil-invoice',
    transform: 'width-20'
  },
  voucher: {
    name: 'uil-ticket',
    transform: 'width-18'
  },
  debit_card: {
    name: 'uil-card-atm',
    transform: 'width-18'
  },
  bank_transfer: {
    name: 'uil-exchange',
    transform: 'width-16'
  },
  safety_pay: {
    name: 'uil-play-circle',
    transform: 'width-16'
  },
  private_label: {
    name: 'uil-tag-alt',
    transform: 'width-16'
  },
  cash: {
    name: 'uil-money-bill',
    transform: 'width-16'
  }
}

export default PAYMENT_METHODS_ICONS
